/**
 * Templates Feature Module
 *
 * Feature module configuration for the templates feature.
 * Handles auto-registration with the Redux store.
 */

import { type FeatureModule } from '@store/features/types';

export const templatesFeature: FeatureModule = {
  id: 'templates',
  name: 'Templates',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {
    // Templates feature uses RTK Query for data fetching
    // No additional setup needed
  },
  cleanup: _store => {
    // No cleanup needed
  },
};

